// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ICbO","clinicsSelect":"styles_clinicsSelect__1s2j0"};